import { render } from "./Servicess.vue?vue&type=template&id=80d7fbf4&scoped=true"
import script from "./Servicess.vue?vue&type=script&lang=js"
export * from "./Servicess.vue?vue&type=script&lang=js"

import "./Servicess.vue?vue&type=style&index=0&id=80d7fbf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-80d7fbf4"

export default script